import { makeAutoObservable, set, toJS } from "mobx";
import SequencesManager, { SequencesFile } from "react-sdk/SequencesManager";
import SoundPlayer from "react-sdk/SoundPlayer";
import AppState, { POPUPS, SCREENS } from "./AppState";
import Minigames from "./Minigames/Minigames";

import FTUE from "./FTUE";
import ObjectiveFile from "./Objectives/ObjectiveFile";
import SaveGame from "./SaveGame";
import Texts from "react-sdk/Texts";
import PopupsManager from "react-sdk/PopupsManager";
import Analytics from "react-sdk/Vertx/Analytics";
import Vues from "./Vues";
import Periods from "./Periods";
import SelectionPhase, { STATUS } from "./SelectionPhase";
import FtueHelper from "./FtueHelper";
import App from "@/components/App/App";

class SequenceScenario {
  mainSeq = null;
  currentElement = null;
  onEnd = null;

  constructor() {
    makeAutoObservable(this);
  }

  init() {


    // NOTE ceci sont les actions/getters appelés depuis les fichiers .data de scénario

    SequencesManager.registerAction("openSequenceScenario", (filename, seqId) => {

      // PopupsManager.close(POPUPS.LOADING)

      this.playSequence(filename, seqId, () => {
      })
    });

    SequencesManager.registerAction("selectPeriod", (id) => {

      
      PopupsManager.close(POPUPS.LOADING)

      Periods.select(id).then(() => {
        PopupsManager.close(POPUPS.LOADING)


        if (AppState.period.type === "selection") {
          AppState.selection = SelectionPhase.get(id)
        }
        this.next()
      })
    });

    SequencesManager.registerGetter("getPeriod", () => {
      if (!AppState.period) return ""
      return AppState.period.id
    });

    SequencesManager.registerGetter("isCurrentPeriod", (id) => {
      if (AppState.period) {
        return AppState.period.id === id
      }
      return false;
    });

    SequencesManager.registerAction("showDialSequence", (filename, id) => {
      // AppState.lockInteraction = false // allow click to skip dials
      
      AppState.dials.playSequence(filename, id, () => {
          // AppState.lockInteraction = true
          this.next()
      });
    });

    SequencesManager.registerAction("lockInteraction", (lock) => {
      AppState.lockInteraction = lock
      this.next()
    })

    SequencesManager.registerAction("showMinigame", (id) => {
      Minigames.play(id, () => this.next());
    });


    SequencesManager.registerAction("showFtue", (ftues) => {

      let ids = []

      if (ftues.includes("!")) {
        ids.push(...ftues.split("!"))
      }
      else {
        ids.push(ftues)
      }

      //fix du bug de boucle

      ids = ids.filter(id => !FtueHelper.hasShownFtue(id))

      if (ids.length > 0) {
        FtueHelper.openFtues(ids, "map", true, () => {
          setTimeout(() => this.next(), 200)
        })
      }
    });

    SequencesManager.registerAction("flushFtue", () => {
      FtueHelper.flushDones()
    });


    SequencesManager.registerAction("ChangeCameraZoom", (zoomScale) => {


      // AppState.lockInteraction = true

      AppState.reaxe_api.toHaxe("map", "ChangeCameraZoom", { zoom: zoomScale }, () => {
        // AppState.nextPeriod = id
        setTimeout(() => {
          // AppState.lockInteraction = false
          this.next()
        }, 200)
      })

    })


    SequencesManager.registerAction("showLocationInfos", (id) => {
      Vues.show(id)
      // setTimeout(() => this.next(), 200)
      this.next()
    });

    SequencesManager.registerAction("hideLocationInfos", () => {


      PopupsManager.close(POPUPS.LOCATION)
      // setTimeout(() => this.next(), 200)
      this.next()
    });

    SequencesManager.registerAction("unlockObjective", (id) => {
      let obj = AppState.soloObjectives.getObjective(id)
      if (obj) {
        obj.sourceObjective.available.force(null, true);
        AppState.soloObjectives.refresh()
      }

      // this.next()

      setTimeout(() => this.next(), 50)

    });

    SequencesManager.registerAction("completeObjective", (id) => {
      let obj = AppState.soloObjectives.getObjective(id)

      if (obj) {
        obj.sourceObjective.completed.force(null, true);
        AppState.soloObjectives.refresh()

        if (obj.parent) {
          var hasOtherObjective = obj.parent.children.some(child => child.state === "ACTIVE")


          if (hasOtherObjective) {


            setTimeout(() => {
              this.next()
              // AppState.lockInteraction = false
            }, 200)
          }
        }
      }
    });

    SequencesManager.registerAction("finishPeriodThenNext", (id) => {
      AppState.reaxe_api.toHaxe("map", "ChangeAllPoiClickable", { clickable: true }, () => {
        FtueHelper.openFtues(["freeRoam"], "mgs", false, () => {
          AppState.nextPeriod = id
          setTimeout(() => {
            // AppState.lockInteraction = false
          }, 200)
        })
      })
    });

    SequencesManager.registerAction("setSaveState", (id, value) => {
      SaveGame.setState(id, value)
    });

    SequencesManager.registerAction("saveGame", () => {
      SaveGame.save()
        .then(() => {
          setTimeout(() => {
            // AppState.lockInteraction = false
            this.next()
          }, 200)
        })
    });

    SequencesManager.registerAction("showUI", (id, visible) => {
      AppState.UI_visibilities = { ...AppState.UI_visibilities, [id]: visible }
      this.next()
      setTimeout(() => {
        // AppState.lockInteraction = false
      }, 200)
    })

    SequencesManager.registerAction("lockHUD", (val) => {
      AppState.lockHud = val
      setTimeout(() => {
        // AppState.lockInteraction = false
        this.next()
      }, 200)
    })


    // permet d'unlock un POI depuis une ligne du SM
    SequencesManager.registerAction("UnlockPoi", (id, ftue_tourid) => {

      // AppState.lockInteraction = true
      let params = { id: id }
      SoundPlayer.playSound("map_newPOI")


      if (AppState.period.type === "map") {
        AppState.reaxe_api.toHaxe("map", "UnlockPoi", params, () => {          
          setTimeout(() => {
            // AppState.lockInteraction = false
            this.next()
          }, 200) // sinon appelé par la fin de la ftue
        })
      }
      else {
        AppState.selection.changeItemStatus(id, STATUS.open, () => {
          setTimeout(() => {
            // AppState.lockInteraction = false
            this.next()
          }, 200)
        })
      }
    })

    // permet d'unlock un POI depuis une ligne du SM
    SequencesManager.registerAction("LockPoi", (id) => {

      if (AppState.period.type === "map") {
        AppState.reaxe_api.toHaxe("map", "LockPoi", id, () => {
          // AppState.lockInteraction = false

          setTimeout(() => {
            // AppState.lockInteraction = false
          }, 200)
        })
      }
      else {
        AppState.selection.changeItemStatus(id, STATUS.locked, () => {
          // AppState.lockInteraction = false

          setTimeout(() => {
            // AppState.lockInteraction = false
          }, 200)
        })
      }

    })
    SequencesManager.registerAction("HidePoi", (id) => {

      if (AppState.period.type === "map") {
        AppState.reaxe_api.toHaxe("map", "HidePoi", id, () => {
          // AppState.lockInteraction = false
          setTimeout(() => {
            // AppState.lockInteraction = false
          }, 200)
        })
      }
      else {
        AppState.selection.changeItemStatus(id, STATUS.invisible, () => {
          // AppState.lockInteraction = false
          setTimeout(() => {
            // AppState.lockInteraction = false
          }, 200)
        })
      }
    })


    SequencesManager.registerAction("HideAllPois", () => {
      if (AppState.period.type === "map") {
        AppState.reaxe_api.toHaxe("map", "HideAllPois", null, () => {
          setTimeout(() => {
            // AppState.lockInteraction = false
          }, 200)
          this.next()
        })
      }
      else {
        AppState.selection.changeAllItemsStatus(STATUS.invisible, () => {
          setTimeout(() => {
            // AppState.lockInteraction = false
          }, 200)
          this.next()
        })
      }
    })

    SequencesManager.registerAction("ChangePoiStatus", (poi_id, status, clickable) => {
      if (AppState.period.type === "map") {
        AppState.reaxe_api.toHaxe("map", "ChangePoiStatus", { id: poi_id, status: status, clickable: clickable }, () => {
          setTimeout(() => {
            // AppState.lockInteraction = false
          }, 200)
          this.next()
        })
      }
      else {
        AppState.selection.changeItemStatus(poi_id, status, () => {
          setTimeout(() => {
            // AppState.lockInteraction = false
          }, 200)
          this.next()
        })
      }
    })

    SequencesManager.registerAction("LaunchEndScreen", () => {
      AppState.setScreen(SCREENS.ECRAN_FINAL)
      setTimeout(() => {
        // AppState.lockInteraction = false
      }, 200)
    });


    SequencesManager.registerGetter("getSaveState", (id) => {
      return SaveGame.getState(id)
    });

    SequencesManager.registerGetter("objectiveCompleted", (id) => {
      let obj = AppState.soloObjectives.getObjective(id)
      if (obj) {
        let completed = ObjectiveFile.isObjCompleted(obj)
        return completed
      }
      console.error("Fichier de sequence, erreur appel objectiveCompleted, auccun objectif avec cette id : " + id)
      return false
    });

    SequencesManager.registerGetter("isCurrentObjective", (id) => {
      // NOTE malgré son nom, on check les rootObjectives
      let obj = AppState.soloObjectives.activeRootObjectives.at(-1)
      if (obj) {
        return obj.id === id
      }
      return false;
    });

    // SequencesManager.registerGetter("isLastObjective", (id) => {
    //   // NOTE malgré son nom, on check les rootObjectives
    //   let obj = AppState.soloObjectives.activeRootObjectives.at(-1)
    //   if(obj) {
    //     return obj.id === id
    //   }
    //   return false;
    // });


    SequencesManager.registerGetter("objectiveInactive", (id) => {
      let obj = AppState.soloObjectives.getObjective(id)
      if (obj) {
        return ObjectiveFile.isObjInactive(obj)
      }
      console.error("Fichier de sequence, erreur appel objectiveInactive, auccun objectif avec cette id : " + id)
      return true
    });

    // TODO
    SequencesManager.registerGetter("poiLocked", (id) => {
      return true;

      // let obj = ObjectivesLib.getObjective(id);
      // if (obj) {
      //   return obj.state === states.INACTIVE;
      // }
      // return false;
    });





    // NOTE les fonctions ci-dessous sont appelées depuis le fichier pois.data

    // window.LP_API = lp_api
    let DM = succubus.data.DataManager.instance

    DM.scriptManager.registerFunction("openSequenceScenario", (filename, seqId) => {
      AppState.reaxe_api.toHaxe("map", "freeze")

      this.playSequence(filename, seqId, () => {
        AppState.reaxe_api.toHaxe("map", "unfreeze")

        setTimeout(() => {
          // AppState.lockInteraction = false
        }, 200)
      })
    });


    DM.scriptManager.registerFunction("openPopupReplayMinigame", () => {
      AppState.reaxe_api.toHaxe("map", "freeze")

      PopupsManager.open(POPUPS.REPLAY_MG, null, () => {
        AppState.reaxe_api.toHaxe("map", "unfreeze")
      })

      setTimeout(() => {
        // AppState.lockInteraction = false
      }, 200)
    });
  }

  addFile(filename, content) {
    // NOTE ceci ajoute automatiquement au SM
    SequencesFile.createFromDataFile(filename, content);
  }

  playSequence(filename, id, onEnd) {
    this.mainSeq = SequencesManager.playSequence(filename, id);
    this.onEnd = onEnd;

    if (this.mainSeq) {
      let el = this.mainSeq.getCurrentElement();
      if (el.Type === "auto") {
        this.next();
      } else {
        this.currentElement = el;
      }
    }
    else {
      if (onEnd) onEnd();
      setTimeout(() => {
        // AppState.lockInteraction = false
      }, 200)
    }
  }

  next() {
    if (this.mainSeq?.hasNext()) {
      let el = this.mainSeq.next();
      if (el.Type === "auto") {
        this.next();
      } else {
        this.currentElement = el;
      }
    } else {
      this.quit();
    }
  }

  quit() {
    SoundPlayer.playSound("music_map");
    this.mainSeq = null;
    this.currentElement = null;
    // AppState.dials.deleteAllCharacters();

    AppState.soloObjectives.refresh()

    // ObjectivesLib.refresh();
    if (this.onEnd) this.onEnd();

    this.onEnd = null;
  }
}

export default new SequenceScenario();
